module.exports = __webpack_public_path__ + "img/logo-merca.140c3162.svg";